module.exports = __webpack_public_path__ + "img/shape-9_yellow-400.7883d5f.png";